module.exports = __webpack_public_path__ + "img/alipay_logo@2x.b7a513f7.png";